export default __webpack_public_path__ + "static/media/escaladecoloresjet.d7738aca.svg";